export default "__VITE_ASSET__ClsOF8sv__"